import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const RequestFormWidgetPriceString = ({ id, label, rawErrors, required }) => {
  const intl = useIntl();
  const error = !!(rawErrors && rawErrors.length > 0);

  return (
    <div className="w-full">
      <label 
        className="inline-block text-[12px] font-bold text-[#212529] font-['Open_Sans'] mt-[0.3vh] mb-1 tracking-tight" 
        htmlFor={id}
      >
        <FormattedMessage id={label} />
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>

      <input
        disabled
        id={id}
        data-cy={id}
        type="text"
        value={intl.formatMessage({ id: 'priceToDefine' })}
        style={{ fontWeight: 'normal', color: 'rgba(0, 0, 0, 0.38)' }}
        className={classNames(
          "w-full border rounded-[4px] !h-[37px] !px-[12px] py-[6px] text-[14px] !font-normal font-['Open_Sans'] transition-all bg-[#efefef] cursor-not-allowed text-[rgba(0,0,0,0.38)]",
          {
            "border-[#dc3545]": error,
            "border-[#ced4da]": !error
          }
        )}
      />

      {error && (
        <p className="order-form-field-error">
          {rawErrors[0]}
        </p>
      )}
    </div>
  );
};

RequestFormWidgetPriceString.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rawErrors: PropTypes.array,
  required: PropTypes.bool,
};

export default RequestFormWidgetPriceString;
